'use client'

import { Icon, Image } from '@vinted/web-ui'
import { ArrowRight16 } from '@vinted/monochrome-icons'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  ElectronicsLandingPageEvent,
  ElectronicsWhySectionCardModel,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

const WhySectionCard = ({
  imageUrl,
  title,
  description,
  linkText,
  linkUrl,
}: ElectronicsWhySectionCardModel) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const handleOnLinkClick = async () =>
    track(
      landingPageEvent({
        event:
          lpVersion === 'buy'
            ? ElectronicsLandingPageEvent.BuyWhyLinkClick
            : ElectronicsLandingPageEvent.SellWhyLinkClick,
        targetDetails: linkUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <article className="electronics__why-card" data-testid="electronics-why-card">
      <div>
        <div className="electronics__why-card-image">
          <Image src={imageUrl} scaling="cover" loading="lazy" />
        </div>
        <h3 className="electronics__why-card-title">{title}</h3>
        <p className="electronics__why-card-description">{description}</p>
      </div>
      <a
        className="electronics__why-card-link"
        href={linkUrl}
        data-testid="electronics-why-card-link"
        onClick={handleOnLinkClick}
      >
        <span>{linkText}</span>
        <span className="electronics__why-card-link-icon">
          <Icon name={ArrowRight16} />
        </span>
      </a>
    </article>
  )
}

export default WhySectionCard
